import { Badge, BlockStack, Box, Card, Icon, InlineStack, Typography } from '@pv-frontend/ui-components-web';

/**
 * The "measurement pending" indicator required by PRD #11. Defining an experiment
 * and enrolling a cohort works end-to-end, but pv-data has no consumer for
 * exposure events yet — so nothing marks an assignment as exposed and no results
 * are measured. This notice makes that limitation unmissable at the top of the
 * experiments screen; `MeasurementPendingBadge` repeats it per experiment.
 */
export function MeasurementPendingNotice() {
    return (
        <Card testID="measurement-pending">
            <Box padding="400">
                <InlineStack gap="300" blockAlign="start" wrap={false}>
                    <Box paddingBlockStart="050">
                        <Icon name="alert-triangle" tone="text-warning" accessibilityLabel="Warning" />
                    </Box>
                    <BlockStack gap="100">
                        <Typography variant="heading-sm" as="h2">
                            Measurement pending
                        </Typography>
                        <Typography variant="body-sm" tone="text-secondary">
                            You can define experiments and enroll cohorts now, but results aren&apos;t being
                            measured yet: pv-data has no consumer for exposure events, so assignments never
                            record a first exposure. Treat enrolled cohorts as staged — not yet analysable.
                        </Typography>
                    </BlockStack>
                </InlineStack>
            </Box>
        </Card>
    );
}

/** Compact per-experiment restatement of the measurement-pending caveat. */
export function MeasurementPendingBadge() {
    return (
        <Badge tone="warning" dot testID="measurement-pending-badge">
            Measurement pending
        </Badge>
    );
}
